import type { SignupState } from "@/models/signup";
import _ from "lodash";
import type { Gender } from "../auth/types";
import { AccountCreate, AccountCreateMirror } from "../utils/types";
import type { NaturalPerson, StaticData } from "./types";

export const factory_account_create_mirror = (
  email: string,
  password: string,
  captchaToken: string,
  codeLangue: string,
  signupState: SignupState,
  staticData: StaticData
): AccountCreateMirror => {
  return {
    acceptCondition: true,
    language: codeLangue.toUpperCase(),
    password,
    captchaToken,
    email,
    codeLangue: codeLangue.toUpperCase(),
    maidenName: null,
    firstName: signupState?.identity?.person?.firstnames ?? "",
    lastName: signupState?.identity?.person?.lastnames ?? "",
    commonName: signupState?.identity?.person?.commonName ?? null,
    commonFirstName: signupState?.identity?.person?.commonFirstName ?? null,
    otherFirstNames: signupState?.identity?.person?.otherfirstnames ?? "",
    jwt_otp: signupState.jwt_otp ?? null,
    gender: (signupState.identity?.person?.gender as Gender) || null,
    birthDate: new Intl.DateTimeFormat("en-US").format(
      signupState.identity?.addressBirth?.birth ?? new Date()
    ),
    countryOfCitizenship:
      staticData.countries.find(
        (country) =>
          country.alpha2.toLowerCase() ===
          (_.first(signupState.identity?.person?.nationalityCodes) ?? "").toLowerCase()
      )?.id ?? -1,
    countryOfCitizenship2:
      staticData.countries.find(
        (country) =>
          country.alpha2.toLowerCase() ===
          ((signupState.identity?.person?.nationalityCodes as string[])[1] ?? "").toLowerCase()
      )?.id ?? null,
    countryOfCitizenship3:
      staticData.countries.find(
        (country) =>
          country.alpha2.toLowerCase() ===
          ((signupState.identity?.person?.nationalityCodes as string[])[2] ?? "").toLowerCase()
      )?.id ?? null,

    countryOfCitizenship4:
      staticData.countries.find(
        (country) =>
          country.alpha2.toLowerCase() ===
          ((signupState.identity?.person?.nationalityCodes as string[])[3] ?? "").toLowerCase()
      )?.id ?? null,

    countryOfBirth: signupState.identity?.addressBirth?.countryCode
      ? parseInt(signupState.identity?.addressBirth?.countryCode)
      : -1,
    birthplace: signupState.identity?.addressBirth?.countryCode
      ? parseInt(signupState.identity?.addressBirth?.countryCode)
      : -1,
    stateOfBirth: signupState.identity?.addressBirth?.zip
      ? signupState.identity?.addressBirth?.cityOfBirth +
        " (" +
        signupState.identity?.addressBirth?.zip +
        ")"
      : signupState.identity?.addressBirth?.cityOfBirth ?? "",
    address: {
      Address1: signupState.identity?.addressResidence?.addressLine ?? "",
      ZipCode: signupState.identity?.addressResidence?.zip ?? "",
      Country: signupState.identity?.addressResidence?.countryCode ?? "-1",
      City: signupState.identity?.addressResidence?.city ?? "",
      Tag: "Résidence principale",
      isPrincipalAddress: true
    },
    phone: {
      MobileIndicatif: signupState.phone?.countryPrefix ?? "",
      MobileNumber: signupState.phone?.phone ?? "",
      main: false
    },
    activityCode: signupState?.identity?.occupation?.activity
      ? parseInt(signupState?.identity?.occupation?.activity)
      : null,
    cspCode: signupState?.identity?.occupation?.CSPcode ?? -1,
    activityDescription: signupState?.identity?.occupation?.description ?? null,
    maximumMonthlyIncome: signupState?.identity?.monthlyIncome?.maximum ?? null,
    minimumMonthlyIncome: signupState?.identity?.monthlyIncome?.minimum ?? null,
    sourcesIncome: signupState?.identity?.sourcesIncome ?? [],
    taxAddress: signupState.identity?.taxAdress ?? [],
    termUuid: signupState.cguItem?.UUID
  };
};

export const factory_account_create = (
  email: string,
  password: string,
  captchaToken: string,
  codeLangue: string,
  signupState: SignupState,
  staticData: StaticData
): AccountCreate => {
  return {
    acceptCondition: true,
    language: codeLangue.toUpperCase(),
    captchaToken,
    password,
    email,
    codeLangue: codeLangue.toUpperCase(),
    maidenName: null,
    firstName: signupState?.identity?.person?.firstnames ?? "",
    lastName: signupState?.identity?.person?.lastnames ?? "",
    commonName: signupState?.identity?.person?.commonName ?? null,
    commonFirstName: signupState?.identity?.person?.commonFirstName ?? null,
    otherFirstNames: signupState?.identity?.person?.otherfirstnames ?? "",
    jwt_otp: signupState.jwt_otp ?? null,
    gender: (signupState.identity?.person?.gender as Gender) || null,
    birthDate: new Intl.DateTimeFormat("en-US").format(
      signupState.identity?.addressBirth?.birth ?? new Date()
    ),
    countryOfCitizenship:
      staticData.countries.find(
        (country) =>
          country.alpha2.toLowerCase() ===
          (_.first(signupState.identity?.person?.nationalityCodes) ?? "").toLowerCase()
      )?.id ?? -1,
    countryOfCitizenship2:
      staticData.countries.find(
        (country) =>
          country.alpha2.toLowerCase() ===
          ((signupState.identity?.person?.nationalityCodes as string[])[1] ?? "").toLowerCase()
      )?.id ?? null,
    countryOfCitizenship3:
      staticData.countries.find(
        (country) =>
          country.alpha2.toLowerCase() ===
          ((signupState.identity?.person?.nationalityCodes as string[])[2] ?? "").toLowerCase()
      )?.id ?? null,

    countryOfCitizenship4:
      staticData.countries.find(
        (country) =>
          country.alpha2.toLowerCase() ===
          ((signupState.identity?.person?.nationalityCodes as string[])[3] ?? "").toLowerCase()
      )?.id ?? null,

    countryOfBirth: signupState.identity?.addressBirth?.countryCode
      ? parseInt(signupState.identity?.addressBirth?.countryCode)
      : -1,
    birthplace: signupState.identity?.addressBirth?.countryCode
      ? parseInt(signupState.identity?.addressBirth?.countryCode)
      : -1,
    stateOfBirth: signupState.identity?.addressBirth?.zip
      ? signupState.identity?.addressBirth?.cityOfBirth +
        " (" +
        signupState.identity?.addressBirth?.zip +
        ")"
      : signupState.identity?.addressBirth?.cityOfBirth ?? "",
    address: {
      Address1: signupState.identity?.addressResidence?.addressLine ?? "",
      ZipCode: signupState.identity?.addressResidence?.zip ?? "",
      Country: signupState.identity?.addressResidence?.countryCode ?? "-1",
      City: signupState.identity?.addressResidence?.city ?? "",
      Tag: "Résidence principale",
      isPrincipalAddress: true
    },
    phone: {
      MobileIndicatif: signupState.phone?.countryPrefix ?? "",
      MobileNumber: signupState.phone?.phone ?? "",
      main: false
    },
    activityCode: signupState?.identity?.occupation?.activity
      ? parseInt(signupState?.identity?.occupation?.activity)
      : null,
    cspCode: signupState?.identity?.occupation?.CSPcode ?? -1,
    activityDescription: signupState?.identity?.occupation?.description ?? null,
    maximumMonthlyIncome: signupState?.identity?.monthlyIncome?.maximum ?? null,
    minimumMonthlyIncome: signupState?.identity?.monthlyIncome?.minimum ?? null,
    sourcesIncome: signupState?.identity?.sourcesIncome ?? [],
    taxAddress: signupState.identity?.taxAdress ?? [],
    termUuid: signupState.cguItem?.UUID
  };
};

export const factory_naturalPerson_edit = (
  naturalPerson: NaturalPerson,
  signupState: SignupState,
  staticData: StaticData
): NaturalPerson => ({
  ...naturalPerson,
  CommonName: signupState?.identity?.person?.commonName ?? null,
  CommonFirstName: signupState?.identity?.person?.commonFirstName ?? null,
  OtherFirstNames: signupState?.identity?.person?.otherfirstnames ?? "",
  Gender: (signupState.identity?.person?.gender as Gender) || null,
  DateOfBirth: {
    date: new Intl.DateTimeFormat("en-US").format(
      signupState.identity?.addressBirth?.birth ?? new Date()
    ),
    timezone_type: 3,
    timezone: "UTC"
  },
  NIF: "",
  CountryOfCitizenship:
    staticData.countries.find(
      (country) =>
        country.alpha2.toLowerCase() ===
        (_.first(signupState.identity?.person?.nationalityCodes) ?? "").toLowerCase()
    )?.id ?? -1,
  CountryOfCitizenship2:
    staticData.countries.find(
      (country) =>
        country.alpha2.toLowerCase() ===
        (
          ((signupState.identity?.person?.nationalityCodes as string[])[1] as string) ?? ""
        ).toLowerCase()
    )?.id ?? null,
  CountryOfCitizenship3:
    staticData.countries.find(
      (country) =>
        country.alpha2.toLowerCase() ===
        (
          ((signupState.identity?.person?.nationalityCodes as string[])[2] as string) ?? ""
        ).toLowerCase()
    )?.id ?? null,

  CountryOfCitizenship4:
    staticData.countries.find(
      (country) =>
        country.alpha2.toLowerCase() ===
        (
          ((signupState.identity?.person?.nationalityCodes as string[])[3] as string) ?? ""
        ).toLowerCase()
    )?.id ?? null,

  countryOfBirth: parseInt(signupState.identity?.addressBirth?.countryCode ?? "-1"),
  Birthplace: signupState.identity?.addressBirth?.countryCode ?? "-1",
  StateOfBirth: signupState.identity?.addressBirth?.cityOfBirth ?? "",
  Address: [],
  AliasMobile: [],
  ActivityCode: parseInt(signupState?.identity?.occupation?.activity ?? "") ?? -1,
  CSPCode: signupState?.identity?.occupation?.CSPcode ?? -1,
  activityDescription: signupState?.identity?.occupation?.description ?? null,
  maximumMonthlyIncome: signupState?.identity?.monthlyIncome?.maximum ?? null,
  minimumMonthlyIncome: signupState?.identity?.monthlyIncome?.minimum ?? null,
  sourcesIncome: signupState?.identity?.sourcesIncome ?? []
});
export const factory_naturalPerson_partial_edit = (
  naturalPerson: NaturalPerson,
  signupState: SignupState,
  staticData: StaticData,
  initialMissingKeys: string[]
) => {
  const personData: Partial<NaturalPerson> = {
    ...naturalPerson
  };
  personData.UUID = undefined;
  personData.identityUuid = undefined;

  const gender = signupState.identity?.person?.gender;
  if (gender && !naturalPerson.Gender) {
    personData.Gender = gender;
  }

  const dateOfBirth = signupState.identity?.addressBirth?.birth;
  if (dateOfBirth) {
    personData.DateOfBirth = {
      date: new Intl.DateTimeFormat("en-US").format(dateOfBirth),
      timezone_type: 3,
      timezone: "UTC"
    };
  }

  const countryOfCitizenship = signupState.identity?.person?.nationalityCodes;
  if ((countryOfCitizenship?.length as number) > 0) {
    personData.CountryOfCitizenship =
      staticData.countries.find(
        (country) =>
          country.alpha2.toLowerCase() === (_.first(countryOfCitizenship) ?? "").toLowerCase()
      )?.id ?? -1;
    personData.CountryOfCitizenship2 =
      staticData.countries.find(
        (country) =>
          country.alpha2.toLowerCase() ===
          ((countryOfCitizenship as string[])[1] ?? "").toLowerCase()
      )?.id ?? null;
    personData.CountryOfCitizenship3 =
      staticData.countries.find(
        (country) =>
          country.alpha2.toLowerCase() ===
          ((countryOfCitizenship as string[])[2] ?? "").toLowerCase()
      )?.id ?? null;
    personData.CountryOfCitizenship4 =
      staticData.countries.find(
        (country) =>
          country.alpha2.toLowerCase() ===
          ((countryOfCitizenship as string[])[3] ?? "").toLowerCase()
      )?.id ?? null;
  }

  const countryOfBirth = signupState.identity?.addressBirth?.countryCode;
  if (countryOfBirth) {
    personData.countryOfBirth = parseInt(countryOfBirth);
  }

  const stateOfBirth = signupState.identity?.addressBirth?.cityOfBirth;
  if (stateOfBirth) {
    personData.StateOfBirth = stateOfBirth;
  }

  const occupation = signupState?.identity?.occupation?.activity;
  if (occupation) {
    personData.ActivityCode = parseInt(occupation);
  }

  const cspCode = signupState?.identity?.occupation?.CSPcode;
  if (cspCode) {
    personData.CSPCode = cspCode;
  }
  const activityDescription = signupState?.identity?.occupation?.description;
  if (activityDescription) {
    personData.activityDescription = activityDescription;
  }

  const maximumMonthlyIncome = signupState?.identity?.monthlyIncome?.maximum;
  if (maximumMonthlyIncome !== undefined) {
    personData.maximumMonthlyIncome = maximumMonthlyIncome;
  }
  const sourcesIncome = signupState?.identity?.sourcesIncome;
  if (sourcesIncome) {
    personData.sourcesIncome = sourcesIncome;
  }

  const minimumMonthlyIncome = signupState?.identity?.monthlyIncome?.minimum;
  if (minimumMonthlyIncome !== undefined) {
    personData.minimumMonthlyIncome = minimumMonthlyIncome;
  }

  const npSignupState = signupState?.identity?.person;
  if (!npSignupState) return personData as NaturalPerson;

  //declarative identity person from the form
  const firstnameSignupState = npSignupState.firstnames;
  if (firstnameSignupState && firstnameSignupState.length > 0)
    personData.FirstName = firstnameSignupState;

  const lastnameSignupState = npSignupState.lastnames;
  if (lastnameSignupState && lastnameSignupState.length > 0)
    personData.LastName = lastnameSignupState;

  const genderSignupState = npSignupState.gender;
  if (genderSignupState) personData.Gender = genderSignupState;

  const otherfirstnameSignupState = npSignupState.otherfirstnames;
  if (otherfirstnameSignupState && otherfirstnameSignupState.length > 0)
    personData.OtherFirstNames = otherfirstnameSignupState;

  const commonFirstnameSignupState = npSignupState.commonFirstName;
  if (commonFirstnameSignupState && commonFirstnameSignupState.length > 0)
    personData.CommonFirstName = commonFirstnameSignupState;

  const commonLastnameSignupState = npSignupState.commonName;
  if (commonLastnameSignupState && commonLastnameSignupState.length > 0)
    personData.CommonName = commonLastnameSignupState;

  if (initialMissingKeys.includes("phone.phone") && signupState.phone) {
    personData.AliasMobile = [
      {
        UUID: "",
        Owner: "",
        Public: false,
        MobileIndicatif: signupState.phone.countryPrefix ?? "",
        Phone: signupState.phone.phone ?? "",
        MobileNumber: signupState.phone.phone ?? "",
        Main: false
      }
    ];
  } else {
    personData.AliasMobile = undefined;
  }

  if (initialMissingKeys.includes("identity.residence") && signupState.identity?.addressResidence) {
    const addr = signupState.identity?.addressResidence;
    personData.Address = [
      {
        Address1: addr.addressLine ?? "",
        ZipCode: addr.zip ?? "",
        Country: addr.countryCode ?? "",
        City: addr.city ?? "",
        Tag: "Résidence principale",
        language: "",
        isPrincipalAddress: true
      }
    ];
  } else {
    personData.Address = undefined;
  }

  if (initialMissingKeys.includes("identity.nif") && signupState.identity?.taxAdress) {
    const nifs = signupState.identity.taxAdress;
    personData.TaxAddress = nifs.map(
      ({ country, tinExist, tin, tinCheck, apiCheck, allowUpdate, AllowContinueQuiz }) => ({
        country,
        tinExist,
        tin,
        tinCheck,
        apiCheck,
        allowUpdate,
        AllowContinueQuiz
      })
    );
  } else {
    personData.TaxAddress = undefined;
  }

  return personData as NaturalPerson;
};
